import { render, staticRenderFns } from "./RequestAdminOptions.vue?vue&type=template&id=4c7d838f"
import script from "./RequestAdminOptions.vue?vue&type=script&lang=js"
export * from "./RequestAdminOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports